module.exports = __webpack_public_path__ + "img/ic_profile_wizard_work_experience.4981fceb.svg";